module.exports = __webpack_public_path__ + "img/goods15.cf0445a1.jpg";